import { useState } from 'react';
import { LuChevronRight, LuExternalLink } from 'react-icons/lu';
import Checkbox from '@/components/Checkbox';

interface TrialPrivacyPolicyStepProps {
  agreed: boolean;
  onAgree: (agreed: boolean) => void;
  onSubmit: () => void;
  onBack: () => void;
  isSubmitting: boolean;
}

export default function TrialPrivacyPolicyStep({
  agreed,
  onAgree,
  onSubmit,
  onBack,
  isSubmitting,
}: TrialPrivacyPolicyStepProps) {
  const [touched, setTouched] = useState(false);
  const showError = touched && !agreed;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setTouched(true);
    if (!agreed) return;
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-8 pt-4">
      <div className="flex flex-col gap-3">
        <label className="text-heading-xxs font-bold md:text-lg" style={{ color: '#262626' }}>
          プライバシーポリシーに
        </label>

        {/* チェックボックスフィールド（他ステップの入力欄と同じ見た目） */}
        <div
          className="flex h-[50px] w-full items-center gap-4 rounded-sm bg-white px-3 text-lg md:h-20"
          style={{ border: `1px solid ${showError ? '#EF4444' : '#d1d1d1'}` }}
        >
          <Checkbox
            checked={agreed}
            onChange={(checked) => {
              onAgree(checked);
              setTouched(true);
            }}
          >
            <span className="text-xs md:text-body-lg">同意する</span>
          </Checkbox>
        </div>

        {showError && (
          <p className="text-[10px] text-red-500 md:text-body-sm">
            プライバシーポリシーへの同意が必要です
          </p>
        )}

        {/* プライバシーポリシーリンク */}
        <div className="flex justify-center">
          <a
            href="https://luumos.com/privacy_policy"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-body-sm"
            style={{ color: '#005FFF' }}
          >
            プライバシーポリシー
            <LuExternalLink size={14} />
          </a>
        </div>
      </div>

      <div className="flex gap-8 max-md:gap-4">
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className="h-[52px] shrink-0 rounded-sm bg-white px-4 text-base font-bold transition-colors hover:bg-gray-50 disabled:opacity-50 max-md:h-[52px] max-md:w-[100px] max-md:px-2 max-md:text-sm"
          style={{ border: '1px solid #d1d1d1', color: '#262626' }}
        >
          戻る
        </button>
        <button
          type="submit"
          disabled={isSubmitting}
          className="flex h-[52px] flex-1 items-center justify-center gap-2 rounded-sm text-base font-bold text-white transition-opacity disabled:opacity-50 max-md:text-sm"
          style={{
            backgroundColor: '#005FFF',
            opacity: !agreed && !isSubmitting ? 0.5 : undefined,
          }}
        >
          {isSubmitting ? '送信中...' : '送信'}
          {!isSubmitting && <LuChevronRight size={24} className="max-md:size-4" />}
        </button>
      </div>
    </form>
  );
}
